export const CsticNames = {
  KITLeft: "kit left",
  KITCenter: "kit center",
  KITRight: "kit right",
  StandardKits: "Standard kits",
  LubricationConnectorOrientation: "LC Orientation",
  LubricationConnectorPosition: "LC Position",
  LubricationConnector: "Lubrication Connector",
  LubricationConnectorAlignment: "LC Alignment",
  LubricationConnectorType: "LC Type",
  EnableCarriageEditButton: "Enable Edit",
};
